import React from 'lib/react';
import {
  EVGrid, EVTypography,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { Link } from 'lib/router';
import { ORDER_PREFERENCES_CUSTOM_COVER_PAGE_ROUTE } from 'constants/RouteConstants';
import { IMAGE_FILES_PATH } from 'constants/AppConstants';
import CompanyLogoLoader from './components/companyLogoLoader/companyLogoLoader.component';
import CompanyLogoStyles from './CompanyLogoStyles';

function CompanyLogo({ companyLogo, isLoading }) {
  const classes = CompanyLogoStyles();
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <CompanyLogoLoader />
    );
  }
  return (
    <EVGrid className={classes.layoutContainer}>
      <EVGrid>
        <EVTypography className={classes.layoutHeader}>
          {t('company_logo__image_title')}
        </EVTypography>
      </EVGrid>
      <EVGrid className={classes.imageContainer}>
        <img
          id="companyLogo"
          className={classes.image}
          src={((companyLogo.fileDescription === null) ? companyLogo.fileData
            : `data:image;base64,${companyLogo.fileData}`)}
          alt={companyLogo.fileDescription}
        />
      </EVGrid>
      <EVGrid>
        <EVTypography className={classes.layoutText}>
          {t('company_logo__image_text')}
          {' '}
          <Link
            id="redirection-link"
            to={ORDER_PREFERENCES_CUSTOM_COVER_PAGE_ROUTE}
            aria-label="Custome cover page"
            className={classes.linkText}
          >
            {t('company_logo__image_redirect_url')}
          </Link>
        </EVTypography>
      </EVGrid>
    </EVGrid>
  );
}

CompanyLogo.defaultProps = {
  companyLogo: {
    fileData: `${IMAGE_FILES_PATH}/image_placeholder.svg`,
    fileDescription: null,
  },
};

CompanyLogo.propTypes = {
  companyLogo: PropTypes.shape(),
  isLoading: PropTypes.string.isRequired,
};

export default CompanyLogo;
